import { colors } from '../../Constant/Color';

function AppButton({ buttontext, onClick, variant = 'primary', disabled = false, className = '' }) {
  const baseStyles = 'px-4 py-2 text-sm font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';

  const getVariantStyles = () => {
    const variantStyles = {
      primary: {
        backgroundColor: disabled ? colors.PRIMARY_LIGHT : colors.PRIMARY,
        color: colors.BG_WHITE,
      },
      secondary: {
        backgroundColor: disabled ? colors.BG_GRAY_LIGHT : colors.BG_GRAY,
        color: colors.TEXT_PRIMARY,
      },
      danger: {
        backgroundColor: disabled ? colors.DANGER_LIGHT : colors.DANGER,
        color: colors.BG_WHITE,
      },
    };
    return variantStyles[variant] || variantStyles.primary;
  };

  const handleMouseEnter = (e) => {
    if (!disabled) {
      if (variant === 'primary') {
        e.target.style.backgroundColor = colors.HOVER_PRIMARY;
      } else if (variant === 'danger') {
        e.target.style.backgroundColor = colors.DANGER;
        e.target.style.filter = 'brightness(0.9)';
      } else {
        e.target.style.backgroundColor = colors.HOVER_BG;
      }
    }
  };

  const handleMouseLeave = (e) => {
    if (!disabled) {
      const styles = getVariantStyles();
      e.target.style.backgroundColor = styles.backgroundColor;
      e.target.style.filter = 'brightness(1)';
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${className} ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
      style={getVariantStyles()}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {buttontext}
    </button>
  );
}

export default AppButton;
